import React, { useState, useContext } from "react";
import { OrganisationDTO } from "../types/organisationDTO";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AuthContext } from "../AuthContext";
import { useTranslation } from 'react-i18next';
import { fi } from 'date-fns/locale';
import { registerLocale } from "react-datepicker";

registerLocale('fi', fi);

type Args = {
  headerText: string;
  organisation: OrganisationDTO;
  submitted: (organisation: OrganisationDTO) => void;
};

const OrganisationForm = ({ organisation, submitted }: Args) => {
  const { t, i18n } = useTranslation();
  const { roles } = useContext(AuthContext);
  const [organisationState, setOrganisationState] = useState(organisation);

  const onSubmit: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault();
    submitted(organisationState);
  };

  const onCancel: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault();
    history.back();
  }

  return (
    <div className="ml-2">
      <form>
        {/* <div className="form-group">
          <label htmlFor="address">Id</label>
          <input
            type="text"
            className="form-control"
            placeholder="Id"
            value={organisationState.id}
            readOnly
          />
        </div> */}
        <div className="form-group">
          <label htmlFor="address">{t('common.name')}</label>
          <input
            type="text"
            maxLength={200}
            disabled={roles.includes("SysAdmin") ? false : true}
            className="form-control"
            placeholder="Name"
            value={organisationState.name}
            onChange={(e) =>
              setOrganisationState({ ...organisationState, name: e.target.value })
            }
          />
        </div>
        <div className="form-group mt-2">
          <label htmlFor="validFrom">{t('common.validFrom')}</label>
          <div>
          <DatePicker
            className="form-control"
            dateFormat={i18n.language === 'en' ? 'yyyy-MM-dd hh:mm' : 'dd.MM.yyyy HH:mm'}
            locale={i18n.language === 'fi' ? 'fi' : 'en'}
            disabled={roles.includes("SysAdmin") ? false : true}
            selected={organisationState.validFrom}
            onChange={(date: Date | null) => date && setOrganisationState({ ...organisationState, validFrom: date })}
            showTimeSelect
          />
          </div>
        </div>
        <div className="form-group mt-2">
          <label htmlFor="description">{t('common.validTo')}</label>
          <div>
          <DatePicker
            className="form-control"
            dateFormat={i18n.language === 'en' ? 'yyyy-MM-dd hh:mm' : 'dd.MM.yyyy HH:mm'}
            locale={i18n.language === 'fi' ? 'fi' : 'en'}
            disabled={roles.includes("SysAdmin") ? false : true}
            selected={organisationState.validTo}
            onChange={(date: Date | null) => date && setOrganisationState({ ...organisationState, validTo: date })}
            showTimeSelect
          />
          </div>
        </div>
        {roles.includes("SysAdmin") && (
         <>
        <button
          className="btn btn-danger mt-3 me-2"
          onClick={onCancel}>
          {t('buttons.cancel')}
        </button>
          <button
          className="btn btn-primary mt-3"
          disabled={!organisationState.name || !roles.includes("SysAdmin")}
          onClick={onSubmit}>
          {t('buttons.save')}
        </button>
        </>
        )}
      </form>
    </div>
  );
};

export default OrganisationForm;
